import { isBrokerWebAuthorization, brokerWebContext } from '@/utils/brokerWebAuthorization'
import {createRouter, createWebHistory} from 'vue-router';
/*浏览器上面进度条*/
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { changeLanguage, getLanguage } from '@/utils/setLang'
import { setCookie, TokenKey, LanguageKey } from '@/utils/cookies'
import { routes } from './routes'
import { trackPageView } from '@/utils/umami'
import {isJSBridgeAvailable} from '@/utils/jsBridge'
import i18n from '@/locales'
import { getBrowserLocale, normalizeLocale } from '@/locales/localeConfig'

NProgress.configure({
    showSpinner: false, // 是否显示加载ico
});

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    let title = import.meta.env.VITE_APP_TITLE||'Mobius Social';
    if (!isBrokerWebAuthorization()) console.log('Router to:', to);

    const isJoinPage = to.path === '/join'

    // /join 是外部注册入口，初始语言固定为 URL lang > 浏览器语言 > US。
    if (isBrokerWebAuthorization()) {
        i18n.global.locale.value = normalizeLocale(brokerWebContext.lang || getBrowserLocale())
    } else if (isJoinPage) {
        const joinLang = to.query && to.query.lang
            ? normalizeLocale(to.query.lang)
            : getBrowserLocale()
        changeLanguage(joinLang)
        setCookie(LanguageKey, joinLang)
    } else if(to.query && to.query.lang){
        try {
            const normalizedLang = normalizeLocale(to.query.lang)
            console.log('Setting language from URL param:', normalizedLang);
            changeLanguage(normalizedLang);
            setCookie(LanguageKey, normalizedLang);
        } catch (error) {
            console.error('Error setting language:', error);
        }
    }else{
        const storedLang = getLanguage();
        changeLanguage(storedLang);
    }

    // 保存 token（用于 H5 Moomoo 授权场景）
    if (!isBrokerWebAuthorization() && to.query && to.query.token) {
        try {
            setCookie(TokenKey, to.query.token)
        } catch (error) {
            console.error('Failed to persist token from query:', error)
        }
    }
    
    //如果设置标题就显示，没设置使用默认
    if (null != to.meta && null != to.meta.titleKey && '' !== to.meta.titleKey) {
        title = i18n.global.t(to.meta.titleKey);
    } else if (null != to.meta && null != to.meta.title && '' !== to.meta.title) {
        title = to.meta.title;
    }
    //非生产环境添加标识
    if ('production' !== import.meta.env.MODE) {
        title = title + ` (${import.meta.env.MODE})`;
    }
    if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        setTimeout(function () {
            document.title = title;
            let _iframe = document.createElement('iframe');
            _iframe.style.display = 'none';
            _iframe.onload = function () {
                setTimeout(function () {
                    document.body.removeChild(_iframe);
                }, 0);
            };
            document.body.appendChild(_iframe);
        }, 0);
    } else {
        document.title = title;
    }
    //浏览器上方显示进度条
    NProgress.start();
    //正常放行
    next();
});

router.afterEach((to, from) => {
    //关闭浏览器上方的进度条
    NProgress.done();
    // 页面访问埋点：统一在路由切换后上报
    if (isBrokerWebAuthorization()) return
    trackPageView({
        url: to?.path || to?.fullPath,
        referrer: from?.fullPath || `${isJSBridgeAvailable() ? '/common-webview' : ''}`
    })
});

/**
 * 捕获错误
 */
router.onError(error => {
    console.warn('路由router错误，error:', error);
    alert('路由错误error:' + error);
});

export default router;
